import { jsx, jsxs } from "react/jsx-runtime";
import { CampaignType } from "../../../types/Campaign.js";
import { FallbackImage } from "../../../Components/FallbackImage.js";
import { getAppConsistentParams } from "../../../utils/appUtils.js";
import { getProductUrl } from "../../../utils/productUtils.js";
import { formatMoney } from "../../../utils/stringUtils.js";
import { ConciergeRewardPillWithText } from "../ConciergeRewardPillWithText.js";
import { isCallState, isOutputState } from "./types.js";
import { sectionFadeInStyle } from "./utils.js";
const cardStyles = `
  .dd-scroll {
    display: flex;
    flex-direction: row;
    overflow-x: auto;
    gap: 10px;
    padding-bottom: 6px;
    scrollbar-width: none;
  }
  .dd-scroll::-webkit-scrollbar { display: none; }

  .dd-card {
    flex: 0 0 220px;
    border: 1px solid #dcdddc;
    border-radius: 12px;
    padding: 14px 14px 18px;
    box-sizing: border-box;
    cursor: pointer;
    transition: background-color 0.2s ease-in-out;
    background: #fff;
    text-decoration: none;
    display: block;
  }
  .dd-card:hover { background-color: #f6f8fa; }

  .dd-card-image {
    width: 60%;
    max-width: 130px;
    aspect-ratio: 1/1;
    background: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 4px auto 12px;
    mix-blend-mode: multiply;
  }
  .dd-card-image img {
    max-height: 100%;
    max-width: 100%;
    object-fit: contain;
  }

  .dd-card-title {
    font-size: 12px;
    font-weight: 500;
    color: #1a1a2e;
    line-height: 1.5;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    height: 4.5em;
    word-break: break-word;
    margin-top: 8px;
  }

  .dd-card-price {
    font-size: 16px;
    font-weight: 600;
    color: #1a1a2e;
    margin-top: 8px;
    margin-bottom: 6px;
  }

  .dd-sold-out-btn {
    width: 100%;
    border: none;
    border-radius: 6px;
    padding: 8px;
    font-size: 12px;
    font-weight: 600;
    cursor: not-allowed;
    background: #e8eaed;
    color: #9b9baf;
    margin-top: 6px;
  }
`;
function DailyDealsPart({
  part,
  onProductClick
}) {
  var _a;
  if (isCallState(part.state)) return /* @__PURE__ */ jsx("div", { className: "concierge-loading", children: "Loading daily deals..." });
  const output = part.output;
  if (!isOutputState(part.state) || !((_a = output == null ? void 0 : output.deals) == null ? void 0 : _a.length)) return null;
  return /* @__PURE__ */ jsxs("div", { className: "concierge-product-sections", children: [
    /* @__PURE__ */ jsx("style", { dangerouslySetInnerHTML: { __html: sectionFadeInStyle + cardStyles } }),
    /* @__PURE__ */ jsxs(
      "div",
      {
        className: "concierge-section",
        style: { animation: "concierge-fade-in 0.35s ease-out both" },
        children: [
          /* @__PURE__ */ jsx("h3", { className: "concierge-section-title", children: "Today's Daily Deals" }),
          /* @__PURE__ */ jsx("div", { className: "dd-scroll", children: output.deals.map((deal) => {
            const urlSearchParams = getAppConsistentParams(window.location.search);
            const href = getProductUrl({ title: deal.title, stacklineSku: deal.sku, urlSearchParams });
            return /* @__PURE__ */ jsxs(
              "a",
              {
                className: "dd-card",
                href,
                target: "_blank",
                rel: "noopener noreferrer",
                children: [
                  /* @__PURE__ */ jsx("div", { className: "dd-card-image", children: deal.imageUrl && /* @__PURE__ */ jsx(
                    FallbackImage,
                    {
                      src: deal.imageUrl,
                      fallbackImage: deal.imageUrl.replace("media.brandclub.com", "media-api.brandclub.com"),
                      alt: deal.title
                    }
                  ) }),
                  /* @__PURE__ */ jsx(
                    ConciergeRewardPillWithText,
                    {
                      rewardAmount: deal.rewardAmount ?? 0,
                      rewardCampaignType: CampaignType.DailyDealsRewardCampaign,
                      baseFontSize: 11
                    }
                  ),
                  /* @__PURE__ */ jsx("div", { className: "dd-card-title", children: deal.title }),
                  /* @__PURE__ */ jsx("div", { className: "dd-card-price", children: formatMoney(deal.price ?? 0) }),
                  !deal.isAvailable && /* @__PURE__ */ jsx("button", { className: "dd-sold-out-btn", disabled: true, children: "Sold out" })
                ]
              },
              deal.sku
            );
          }) })
        ]
      }
    )
  ] });
}
export {
  DailyDealsPart
};
//# sourceMappingURL=DailyDealsPart.js.map
